export const GAME_CONFIG = Object.freeze({
  tickRate: 20,
  snapshotRate: 10,
  chunkSize: 1000,
  renderDistance: 1,
  tileSize: 25,
  safeZone: Object.freeze({ x: 500, y: 500, radius: 260 }),
  zone: Object.freeze({ minX: -1000, maxX: 2000, minY: -1000, maxY: 2000 }),
  worldSeed: 0x4d45544f,
  maxCoordinate: 1_000_000,
  player: Object.freeze({
    baseHealth: 200,
    healthPerLevel: 30,
    speed: 300,
    attackRange: 110,
    attackCooldownMs: 400,
    baseDamage: Object.freeze({ ashHound: 18, ridgeWolf: 20, redTuskRaider: 23, dragonMonolith: 18 }),
    damagePerLevel: 1.5,
    skillDamagePerLevel: 0.6
  }),
  enemy: Object.freeze({
    perChunk: 8,
    aggroRange: 500,
    leashRange: 850,
    attackRange: 50,
    respawnMs: 120_000,
    ashHound: Object.freeze({ health: 32, damage: 7, speed: 175, xp: 20, attackCooldownMs: 1800 }),
    ridgeWolf: Object.freeze({ health: 48, damage: 10, speed: 165, xp: 28, attackCooldownMs: 1700 }),
    redTuskRaider: Object.freeze({ health: 70, damage: 13, speed: 140, xp: 38, attackCooldownMs: 1600 }),
    dragonMonolith: Object.freeze({ health: 900, damage: 0, speed: 0, xp: 180, attackCooldownMs: 999999 }),
    crimsonWarden: Object.freeze({ health: 2200, damage: 28, speed: 108, xp: 520, attackCooldownMs: 1300, attackRange: 78, boss: true }),
    monolithRespawnMs: 300_000,
    bossRespawnMs: 900_000
  }),
  progression: Object.freeze({
    baseXpToLevel: 120,
    xpScalingFactor: 1.3,
    maxLevel: 100
  }),
  network: Object.freeze({
    inputRate: 20,
    snapshotRadius: 900,
    reconnectGraceMs: 10_000
  }),
  items: Object.freeze({
    pickupRange: 50,
    lifetimeMs: 120_000,
    healthPotionHeal: 60,
    potionCooldownMs: 1500
  })
});

export function xpForLevel(level) {
  return Math.floor(
    GAME_CONFIG.progression.baseXpToLevel *
    Math.pow(GAME_CONFIG.progression.xpScalingFactor, Math.max(0, level - 1))
  );
}

export function maxHealthForLevel(level) {
  return GAME_CONFIG.player.baseHealth +
    GAME_CONFIG.player.healthPerLevel * Math.max(0, level - 1);
}
